export default __webpack_public_path__ + "static/media/ocr_bg.b94fbe1e.jpg";